import styled from "styled-components";

export const WorkspaceContentStack = styled.div.attrs({ className: "space-y-5" })``;

export const PlayerPerformanceSkeletonStack = styled.div.attrs({
  className: "space-y-8",
})``;

export const PlayerPerformanceSkeletonWorkspace = styled.div.attrs({
  className: "space-y-4",
})``;
